import getInitials from "common/utils/getInitials";
import isLightColor from "common/utils/isLightColor";
import stringToColor from "common/utils/stringToColor";
import { useMemo } from "react";
import ImageComponent from "../ImageComponent/OldImageComponent";
import ImageFromStrapiMedia from "../ImageFromStrapiMedia/ImageFromStrapiMedia";

interface IAvatar {
  name?: string;
  image?: any;
  size?: string;
}

const getFontSize = (size: string) => {
  const n = Number(size);
  if (n <= 5) return "text-[8px]";
  if (n <= 7) return "text-[10px]";
  if (n <= 9) return "text-xs";
  return "text-sm";
};

function Avatar({ name, image, size = "6" }: IAvatar) {
  const initials = useMemo(() => getInitials(name), [name]);
  const backgroundColor = useMemo(() => stringToColor(name || ""), [name]);
  const textColor = isLightColor(backgroundColor) ? "text-black" : "text-white";
  const fontSize = getFontSize(size);

  const content = image ? (
    <ImageComponent image={ImageFromStrapiMedia(image).uri} />
  ) : (
    <span className={`${fontSize} font-medium leading-none ${textColor}`}>
      {initials}
    </span>
  );
  return (
    <span
      className={`inline-flex overflow-hidden items-center justify-center rounded-full border border-white w-${size} h-${size}`}
      style={{ backgroundColor }}
    >
      {content}
    </span>
  );
}

export default Avatar;
